import PostForm from '../components/PostForm'

function NewPostPage() {
  return (
    <>
      <PostForm method="POST" post=""></PostForm>
    </>
  )
}

export default NewPostPage
